import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage, withFormik } from 'formik';
import * as yup from 'yup'; // Form Debugger
// import { Debug } from "./Debug";

import { Row, Col, Button } from 'react-bootstrap';
import Heading from '../heading/Heading';
import { Loading } from '../state'; // Global Element

import { FormInput } from './elements'; // Validation schema

import { validation } from './util/validation'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
import { formStart, formComplete } from '../../util';

var formCompleteTracker = function formCompleteTracker() {
  formComplete({
    identifier: 'NewsletterForm',
    name: 'Newsletter'
  });
};

var formikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      firstName: props.model.firstName,
      lastName: props.model.lastName,
      emailAddress: props.model.emailAddress,
      zipCode: props.model.zipCode,
      promotionId: props.model.promotionId.value
    };
  },
  validationSchema: yup.object().shape({
    firstName: validation.firstName,
    lastName: validation.lastName,
    emailAddress: validation.emailAddress,
    zipCode: validation.zipCode
  }),
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props;

    if (typeof props.submitHandler !== 'function') {
      return false;
    }

    formCompleteTracker();
    props.submitHandler(values);

    if (props.closeModal) {
      props.closeModal();
    }
  },
  displayName: 'NewsletterForm' // helps with React DevTools

});

var NewsletterForm = function NewsletterForm(props) {
  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      promotionId = props.promotionId,
      changeHandler = props.changeHandler,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$results = props.results,
      results = _props$results === void 0 ? {} : _props$results;
  var initHasStarted = false;

  var _useState = useState(initHasStarted),
      _useState2 = _slicedToArray(_useState, 2),
      hasStarted = _useState2[0],
      setHasStarted = _useState2[1];

  var formStartTracker = function formStartTracker(event) {
    if (!hasStarted) {
      setHasStarted(true);
      formStart({
        identifier: 'NewsletterForm',
        name: 'Newsletter'
      });
    }

    return changeHandler(event);
  };

  var subscribeClick = function subscribeClick(id, event) {
    var target = event.target;
    changeHandler(event);
    var data = {
      gtm: {
        uniqueEventId: id,
        elementTarget: target.name === 'zipCode' ? target.value : '',
        elementId: (target === null || target === void 0 ? void 0 : target.id) || ""
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "firstName",
    label: "First Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: formStartTracker
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "lastName",
    label: "Last Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    type: "email",
    name: "emailAddress",
    label: "Email Address",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "zipCode",
    label: "Zip Code",
    component: FormInput,
    className: "cb-form__input--full",
    id: "subscribe-zipcode",
    changeFullHandler: subscribeClick.bind(null, '54')
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "d-none"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: promotionId,
    name: "promotionId",
    label: "Promotion ID",
    component: FormInput,
    className: "cb-form__input--full"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    disabled: isLoading,
    id: "subscribe-button",
    className: "cb-button-primary w-100",
    onClick: subscribeClick.bind(null, '53')
  }, "Subscribe")))));
};

function mapStateToProps(state) {
  return {
    isLoading: state.newsletter.isLoading,
    results: state.newsletter.results
  };
}

export default connect(mapStateToProps)(formikEnhancer(NewsletterForm));